<div class="bs-card card-no-border mat-elevation-z1 panel-card indexed-visualization-panel" #tableCard>
  <div class="bs-card-header gap-1 flex-nowrap h-auto">
    <div class="flex-1 flex flex-wrap min-w-0 justify-between">
      <!-- <h5> -->
      <!-- <i [ngClass]="currentIndex.iconClass" class="fa fa-icon pad-right"></i> -->
      <mat-form-field subscriptSizing="dynamic" class="bold-form-field w-[300px]">
        <mat-select hideSingleSelectionIndicator [value]="selectedConfiguration.config" (selectionChange)="indexChanged($event)">
          <mat-option *ngFor="let config of panelConfigs" [value]="config">
            {{config.label ?? config.name | translate: locale | async}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- </h5> -->
      <div class="flex flex-wrap gap-x-2">
        <ng-container *ngFor="let selectedMetric of selectedMetrics; let i = index">
          <mat-form-field *ngIf="panelMetrics?.length > 1" subscriptSizing="dynamic">
            <mat-select hideSingleSelectionIndicator [value]="selectedMetric" (selectionChange)="selectedMetricChanged($event, i)">
              <mat-option *ngFor="let panelMetric of panelMetrics" [value]="panelMetric.name">
                {{panelMetric.displayName ?? panelMetric.name | translate: locale | async}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="flex items-center -my-1.5">
      <button *ngIf="!this.panelConfig.disableExpand" mat-icon-button class="toggle-expand-button nofocus" appToggleExpandoCard [scrollToElement]="tableCard" (onExpandoClick)='toggleExpanded($event)'>
        <mat-icon class="fa-primary">fullscreen</mat-icon>
      </button>
      <ng-container *ngIf="selectedConfiguration.config.helpTextKey">
        <button title="Help" [matMenuTriggerFor]="menu" class="inline-flex items-center justify-center w-6 rounded py-2 hover:bg-gray-50">
          <i class="fa fa-primary fa-ellipsis-v" style="font-size: 1.4em;"></i>
        </button>
        <mat-menu #menu="matMenu">
                <!-- <ng-container *ngIf="!!exportName">
        <button mat-menu-item style="outline: none;" (click)="printExcel(exportName, false)">Excel</button>
        <button mat-menu-item style="outline: none;" (click)="printExcel(exportName, true)">Excel - {{'Export All' |
            translate: locale}}</button>
        </ng-container> -->
          <button title="Help" mat-menu-item style="outline: none;" (click)="openHelpTextClicked()">
            {{'Help' | translate: locale | async}}
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </div>
  <!-- visualization/element -->
  <div class="flex-1 min-h-0 overflow-y-auto">
    <ng-template dynamicComponent></ng-template>
  </div>
</div>
